import * as React from "react";
import { Dialog, Button, Icon } from "@app/components";
import {
  ButtonContainer,
  ConfirmationContentWrapper,
  DialogFooter,
  ConfirmationContent,
} from "./delete-component";
import { FlexWrapper } from "../commonStyles";

type Props = {
  onClose: (e: any) => void;
  deleteChild: (e: any) => void;
  dialogTitle?: string;
  deleteText: string;
  confirmationText: string;
  confirmationMsg: string;
  noTitle?: boolean;
  HandleAddStudent?:any;
};

export default function Pill({ dialogTitle, confirmationText, confirmationMsg, onClose, deleteChild, deleteText, noTitle }: Props) {
  return (
    <Dialog title={dialogTitle} noTitle={noTitle} onClose={onClose}>
      <ConfirmationContentWrapper className={noTitle ? 'alt-padding' : ''}>
        <FlexWrapper className="mb-2 row-on-mobile" style={{ paddingRight: '24px' }}>
          <div className="mr-8">
            <Icon name="exclamation" />
          </div>
          <h4 className="secondary-header m-0">{confirmationText}</h4>
        </FlexWrapper>
        <ConfirmationContent className="m-0">
          {confirmationMsg}
        </ConfirmationContent>
      </ConfirmationContentWrapper>
      <DialogFooter className="with-no-border alt-padding alt-height">
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>
        <ButtonContainer
          disabled={deleteText === "Deleting..."}
          className="w-unset"
        >
          <Button variant="danger" onClick={deleteChild}>
            {deleteText}
          </Button>
        </ButtonContainer>
      </DialogFooter>
    </Dialog>
  );
}
